<script>
import Layout from "../../layouts/no-menu/main-no-menu";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Register from "@/components/crm/register.vue";

import { crmMethods, crmComputed } from "@/state/helpers";

/**
 * Starter component
 */
export default {
    page: {
        title: "Register",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: { Layout, PageHeader, Register },
    computed: {
        ...crmComputed,
    },
    data() {
        return {
            title: "Register",
            items: [],
        };
    },
    methods: {
        ...crmMethods,
    },
};
</script>
<template>
    <Layout>
        <PageHeader />
        <Register />
    </Layout>
</template>
